module.exports = {
  apiHost: "https://api.whiterock.sensoreal.app",
  assetsHost: "https://assets.whiterock.sensoreal.app",
  contact: {
    address: "Sandstone Boulevard, White Rock QLD 4306",
    email: "info@mywhiterock.com.au",
    phone: "1300 317 518",
    website: "https://mywhiterock.com.au"
  },
  formTemplate: "intrapac",
  header: {
    logo:
      "https://mywhiterock.com.au/wp-content/themes/whiterock-v2/images/whiterock-logo.svg",
    text: {
      en: "Your WhiteRock Selections",
      ar: ""
    },
    color: "fff"
  },
  langs: [{ code: "en", dir: "ltr" }],
  footerLogo: "",
  links: {
    instagram: "https://www.instagram.com/mywhiterock/",
    facebook: "https://www.facebook.com/mywhiterock4306",
    privacy: "https://mywhiterock.com.au/privacy-policy/"
  },
  style: {
    primaryColor: "#63bf82",
    textColor: "#fff"
  }
};
